class ModalTracker {
  constructor() {
    this.modalCount = 0;
    this.listeners = [];
  }

  increment() {
    this.modalCount += 1;
    this.notify();
  }

  decrement() {
    this.modalCount -= 1;
    this.notify();
  }

  notify() {
    const isAnyModalOpen = this.modalCount > 0;
    this.listeners.forEach((listener) => {
      return listener(isAnyModalOpen);
    });
  }

  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      const index = this.listeners.indexOf(listener);
      if (index > -1) this.listeners.splice(index, 1);
    };
  }
}

export default new ModalTracker();
